import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Payment, PaymentMethodControllerService} from '../../@services/gen';
import {NotificationService} from '../../@services/notification.service';

@Component({
  selector: 'app-payment-method-edit-dialog',
  templateUrl: './payment-method-edit-dialog.component.html',
  styleUrls: ['./payment-method-edit-dialog.component.scss'],
})
export class PaymentMethodEditDialogComponent implements OnInit {
  payment: Payment;
  managerName: string;
  remark: string;
  referenceNo: string;
  
  paymentMethods: any[] = [];
  selectedPaymentMethodId: number;
  selectedPaymentMethodName: string;
  currentPaymentMethod: any;
  
  isLoading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<PaymentMethodEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paymentMethodService: PaymentMethodControllerService,
    private ns: NotificationService
  ) {
    this.payment = data.payment;
    this.managerName = data.managerName;
    this.remark = data.remark;
    this.currentPaymentMethod = this.payment.paymentMethod;
    this.selectedPaymentMethodId = this.payment.paymentMethod?.id;
    this.selectedPaymentMethodName = this.payment.paymentMethod?.name;
  }

  ngOnInit(): void {
    this.loadPaymentMethods();
  }

  loadPaymentMethods() {
    this.isLoading = true;
    
    this.paymentMethodService.getPaymentMethodKeyValuePost({}).subscribe({
      next: (res) => {
        this.paymentMethods = res
          .map(pm => ({
            id: parseInt(pm.key),
            name: String(pm.value),
            logoUrl: (pm.data as any)?.logoUrl
          }))
          .filter(pm => !pm.name.toLowerCase().includes('staff meal'));
        
        this.isLoading = false;
      },
      error: (err) => {
        this.ns.showNotification({
          message: 'Failed to load payment methods',
          icon: 'fa fa-exclamation-circle'
        });
        this.isLoading = false;
      }
    });
  }

  onPaymentMethodChange(paymentMethodId: number) {
    this.selectedPaymentMethodId = paymentMethodId;
    const selected = this.paymentMethods.find(pm => pm.id === paymentMethodId);
    this.selectedPaymentMethodName = selected?.name;
  }

  canSave(): boolean {
    return this.selectedPaymentMethodId !== null 
      && this.selectedPaymentMethodId !== this.currentPaymentMethod?.id
      && !!this.remark && this.remark.trim().length > 0;
  }

  save() {
    if (!this.canSave()) {
      return;
    }

    const selectedMethod = this.paymentMethods.find(pm => pm.id === this.selectedPaymentMethodId);
    
    this.dialogRef.close({
      process: 'save',
      newPaymentMethodId: this.selectedPaymentMethodId,
      newPaymentMethodName: selectedMethod?.name,
      managerName: this.managerName,
      remark: this.remark,
      referenceNo: this.referenceNo
    });
  }

  cancel() {
    this.dialogRef.close({ process: 'cancel' });
  }
}
